<template>
  <div
    v-if="
      !dataContract?.nganluongContractS3Url ||
      dataContract?.nganluongContractS3Url?.length <= 0 ||
      isHiddenFilePdf
    "
  >
    <div class="contract" v-if="dataContract.groupService === 'SELL'">
      <Header :groupService="dataContract.groupService"></Header>
      <p class="txt-center fonsize-16 txt-tranf">
        <b>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM </b>
      </p>
      <p class="txt-center fonsize-16">
        <b>Độc lập – Tự do – Hạnh phúc</b>
      </p>
      <p class="txt-center fonsize-16">***</p>
      <p class="txt-tranf txt-center fonsize-20">
        <b>HỢP ĐỒNG CUNG CẤP GIẢI PHÁP CHUYỂN ĐỔI SỐ NEXT360</b>
      </p>
      <p class="txt-center">
        (Số: <mark v-if="!isHiddenFilePdf">{{ dataContract?.nganluongCode }}</mark>
        <span v-else>{{ dataAppendix?.appendixNganluongConvert?.nganluongContractCode }}</span
        >)
      </p>
      <h3 style="margin-top: 30px">Căn cứ:</h3>
      <ul class="form-style">
        <li>
          Bộ Luật Dân sự được Quốc hội nước Cộng hòa xã hội chủ nghĩa Việt Nam thông qua ngày 24
          tháng 11 năm 2015, có hiệu lực từ ngày 01 tháng 01 năm 2017 và các văn bản hướng dẫn thi
          hành;
        </li>
        <li>
          Luật Thương mại được Quốc hội nước Cộng hòa xã hội chủ nghĩa Việt Nam thông qua ngày 14
          tháng 6 năm 2005, có hiệu lực từ ngày 01 tháng 01 năm 2006 và các văn bản hướng dẫn thi
          hành;
        </li>
        <li>
          Căn cứ Nghị định số 71/2007/NĐ-CP ngày 03 tháng 5 năm 2007 của Chính phủ quy định chi tiết
          và hướng dẫn thực hiện một số điều của Luật Công nghệ thông tin về công nghiệp công nghệ
          thông tin;
        </li>
      </ul>
      <div>
        Hôm nay, ngày
        <mark v-if="!isHiddenFilePdf">{{ dataContract.effectiveFromDTO | formatDate }}</mark>
        <div v-else>
          <mark v-if="dataAppendix?.dateSignAppendixDTO">{{
            dataAppendix.dateSignAppendixDTO | formatDate
          }}</mark>
          <mark v-else-if="dataAppendix?.dateCreatedAppendixDTO">{{
            dataAppendix.dateCreatedAppendixDTO | formatDate
          }}</mark>
          <mark v-else>{{ new Date() | formatDate }}</mark>
        </div>
        , tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:
      </div>

      <p class="fonsize-16 txt-tranf">
        <b>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p><b>(sau đây được gọi là “BÊN A”)</b></p>
      <p>
        Địa chỉ: Tầng 3, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <ul class="form">
        <li>Điện thoại: 1900-2079</li>
        <li>Mã số thuế: 0106001236</li>
        <li>Đại diện: <b>Ông NGUYỄN TIẾN LƯỢNG</b></li>
        <li>Chức vụ: <b>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b></li>
      </ul>
      <p>Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026</p>
      <p class="fonsize-16 txt-tranf flex">
        <span> <b>BÊN B:</b></span>
        <mark
          ><b>{{ customerInfo ? customerInfo.merchantName : '' }}</b></mark
        >
      </p>
      <p><b>(sau đây được gọi là “BÊN B”)</b></p>
      <p>
        <span>Họ và tên người đại diện: </span>
        <mark
          ><b>{{ customerInfo ? customerInfo.customerName : '' }}</b></mark
        >
      </p>
      <p>
        <span>Số CMND/Hộ chiếu/Thẻ căn cước:</span>
        <mark>{{ customerInfo ? customerInfo.passport : '' }}</mark>
        <span>; Nơi cấp:</span>
        <mark>{{ customerInfo ? customerInfo.placeOfIssue : '' }}</mark>
      </p>
      <p
        v-if="
          dataContract.typeCustomer &&
          (dataContract.typeCustomer === 'HOUSEHOLD' || dataContract.typeCustomer === 'COMPANY')
        "
      >
        <span>Mã số thuế doanh nghiệp/ Số đăng ký kinh doanh: </span>
        <mark>{{ customerInfo ? customerInfo.businessRegistrationNumber : 'Không có' }}</mark>
      </p>
      <p>
        <span>Địa chỉ:</span>
        <mark
          >{{ customerInfo ? customerInfo.address : 'Không có' }}
          <!-- {{ customerInfo ? customerInfo.ward : "Không có" }},
          {{ customerInfo ? customerInfo.district : "Không có" }},
          {{ customerInfo ? customerInfo.city : "Không có" }} -->
        </mark>
      </p>
      <span v-if="!(customerInfo && customerInfo.accIdType && customerInfo.accIdType === 'MOBILE')"
        >Email:
        <mark
          >{{ customerInfo ? customerInfo.email : 'Không có' }} - {{ customerInfo.accIdType }}</mark
        >
      </span>
      <span> Điện thoại:</span>
      <mark>
        {{ customerInfo ? customerInfo.mobile : 'Không có' }}
      </mark>
      <p><br /></p>
      <p>
        Sau khi xem xét, Các Bên cùng đồng ý ký kết và thực hiện Hợp Đồng Cung Cấp Giải Pháp Chuyển
        Đổi Số Next360 (“Hợp đồng”) với các điều khoản dưới đây:
      </p>
      <div class="dieukhoan">
        <label><b>ĐIỀU 1. NỘI DUNG HỢP ĐỒNG</b> </label>
        <ul class="dk-list">
          <li>
            <span>1.1.</span> Nội dung: Bên A đồng ý cung cấp cho Bên B Gói giải pháp chuyển đổi số
            NEXT360 để sử dụng cho việc quản lý hoạt động kinh doanh của B bao gồm: các Phần mềm
            quản lý Kinh doanh và các Phần mềm quản lý Doanh nghiệp. Chi tiết Gói giải pháp được quy
            định tại Phụ lục của Hợp Đồng này. Dịch vụ này không bao gồm các dịch vụ được liên kết
            với Phần mềm được cung cấp bởi Bên thứ ba (nếu có);
          </li>
          <li>
            <span>1.2.</span> Hình thức: Bên A sẽ cung cấp giải pháp bằng cách cấp tài khoản trên
            phần mềm, phần cứng (nếu có) của Bên A cho Bên B sử dụng trong vòng 03 (ba) ngày làm
            việc kể từ ngày Bên B thanh toán toàn bộ Phí dịch vụ (đối với phần mềm) và giá (đối với
            thiết bị phần cứng) theo Phụ lục của Hợp đồng này;
          </li>
          <li>
            <span>1.3.</span> Thời hạn cung cấp dịch vụ: đăng ký 01 (một) lần duy nhất và thời hạn
            sử dụng theo đúng thời gian mà Bên B đã đăng ký trong Phụ lục của Hợp đồng này.
          </li>
        </ul>
      </div>

      <div class="dieukhoan">
        <label><b>ĐIỀU 2. GIÁ TRỊ HỢP ĐỒNG</b></label>
        <p>Giá trị Hợp đồng được quy định chi tiết trong Phụ lục của Hợp đồng này.</p>
      </div>

      <div class="dieukhoan">
        <label><b>ĐIỀU 3. THANH TOÁN</b></label>
        <ul class="dk-list">
          <li>
            <span>3.1.</span>Phương thức thanh toán: Bên B thanh toán 100% Giá trị hợp đồng theo quy
            định tại Điều 2 Hợp Đồng cho Bên A ngay khi ký kết Hợp đồng này;
          </li>
          <li>
            <span>3.2.</span>Hình thức thanh toán: Bên B thanh toán bằng hình thức quẹt thẻ ngân
            hàng trên thiết bị mPOS thông qua Chuyên viên tư vấn giải pháp của Bên A hoặc chuyển
            khoản vào tài khoản ngân hàng của Bên A, với thông tin như sau:
            <br />
            <div style="margin-left: 20px">
              <p>
                Tên chủ tài khoản: <b>CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b
                ><br />
                Số tài khoản: <b>11001010157634</b><br />
                Tại ngân hàng: <b>TMCP Hàng Hải Việt Nam</b><br />
                Chi nhánh: <b>Sở GD - PGD Nam Hà Nội</b><br />
                Nội dung chuyển tiền:
                <b>Là mã phiếu thu được bên A thông báo sau khi ký hợp đồng</b>
              </p>
            </div>
          </li>
          <li>
            <span>3.3.</span>Sau khi hoàn tất thủ tục thanh toán, Bên A sẽ xuất hóa đơn tài chính
            cho Bên B theo thông tin trên Hợp Đồng này.
          </li>
        </ul>
      </div>

      <div class="dieukhoan">
        <label><b>ĐIỀU 4. QUYỀN VÀ TRÁCH NHIỆM CÁC BÊN</b></label>
        <ul class="dk-list">
          <li>
            <b><span>4.1.</span>Quyền và trách nhiệm của Bên A:</b>
          </li>
        </ul>
      </div>
      <ul class="form-style-base">
        <li>
          Bên A chịu trách nhiệm thiết lập tài khoản, cung cấp phần mềm và phần cứng cho Gói giải
          pháp (nếu có) để Bên B sử dụng, bao gồm:<br />
          - Thiết lập tài khoản;<br />
          - Cài đặt và hướng dẫn sử dụng giải pháp;<br />
          - Hỗ trợ tư vấn, giải đáp thắc mắc, lỗi kỹ thuật về phần mềm, phần cứng hoặc gia hạn hợp
          đồng thông qua Chuyên viên tư vấn giải pháp, email hotro@nextpay.vn hoặc Tổng đài
          1900636956.
        </li>
        <li>
          Thông báo trước cho Bên B về thời gian tiến hành nâng cấp, bảo trì Phần mềm qua email,
          điện thoại hoặc trực tiếp trên Phần mềm.
        </li>
        <li>
          Giải quyết các khiếu nại hợp lý của Bên B về chất lượng thông tin, chất lượng dịch vụ và
          số liệu trên phần mềm trong thời gian nhanh nhất vào các ngày làm việc;
        </li>
        <li>
          Tuân thủ tuyệt đối những cam kết đưa ra trong Hợp đồng này và nội dung Phụ lục đi kèm (nếu
          có);
        </li>
        <li>
          Đơn phương tạm ngừng cung cấp dịch vụ hoặc chấm dứt Hợp đồng trước thời hạn, không phụ
          thuộc vào việc thông báo chấm dứt quy định tại Điều 5 dưới đây, khi Bên B sử dụng giải
          pháp của Bên A không theo đúng các cam kết trong Hợp đồng này, bao gồm nội dung trong các
          Phụ lục (nếu có), Điều khoản sử dụng phần mềm/ứng dụng của các phần mềm tương ứng hoặc
          không tuân thủ các quy định pháp luật, các thể lệ và quy định về khai thác dịch vụ hiện
          hành của Việt Nam;
        </li>
        <li>
          Cam kết đảm bảo bí mật dữ liệu và các thông tin về Bên B, chỉ được phép tiết lộ thông tin
          khi có yêu cầu của cơ quan chức năng theo quy định của pháp luật hoặc theo yêu cầu của Hợp
          đồng này và phải báo cho Bên B nội dung đã tiết lộ;
        </li>
        <li>
          Bồi thường thiệt hại cho Bên B trong trường hợp Bên A vi phạm các nghĩa vụ đã cam kết tại
          Hợp đồng này và gây thiệt hại cho Bên B.
        </li>
      </ul>
      <div class="dieukhoan">
        <ul class="dk-list">
          <li>
            <b><span>4.2. </span>Quyền và trách nhiệm của Bên B:</b>
          </li>
        </ul>
      </div>
      <ul class="form-style-base">
        <li>
          Bên B phải đảm bảo thực hiện và tuân thủ đúng nội dung các điều khoản tại Hợp đồng này,
          bản Phụ lục đi kèm Hợp đồng (nếu có);
        </li>
        <li>
          Tuân thủ các quy định pháp luật về bảo hộ quyền sở hữu trí tuệ đối với Phần mềm, Phần cứng
          mà Bên A đang cung cấp cho Bên B.
        </li>
        <li>
          Tự chịu trách nhiệm trước pháp luật nếu Bên B sử dụng dịch vụ phần mềm của Bên A và/hoặc
          các dịch vụ liên kết với Phần mềm được cung cấp bởi Bên thứ ba trái với quy định của pháp
          luật và Hợp đồng này.
        </li>
        <li>
          Bên B cam kết không sử dụng Phần mềm để tuyên truyền nội dung đồi trụy, chống phá nhà
          nước, phát tán thư rác hay các thông tin không mong muốn đến những cá nhân, tổ chức dưới
          mọi hình thức hay thực hiện các hành vi vi phạm pháp luật khác.
        </li>
        <li>
          Cung cấp thông tin theo yêu cầu để sử dụng phần mềm và đồng thời đảm bảo sự đúng đắn,
          chính xác của thông tin này. Bên B đồng ý cho phép Bên A được sử dụng thông tin để thực
          hiện cung cấp dịch vụ và thông tin liên hệ với Bên B.
        </li>
        <li>
          Tuân thủ theo đúng các quy định khi đăng ký và sử dụng và có trách nhiệm thanh toán các
          chi phí của các dịch vụ liên kết với Phần mềm được cung cấp thêm bởi Bên A, các công ty
          liên kết của Bên A, hoặc Bên thứ ba. Bên B hiểu rằng việc vi phạm các điều khoản sử dụng
          hoặc thanh toán không đúng hạn đối với các dịch vụ này có thể dẫn tới việc tài khoản sử
          dụng Phần mềm bị đình chỉ hoạt động cho tới khi các vi phạm được khắc phục và các chi phí
          được thanh toán đầy đủ.
        </li>
        <li>
          Không được thực hiện các hành vi xâm hại tới việc hoạt động bình thường của phầm mềm, bao
          gồm nhưng không giới hạn tại việc gửi hoặc lưu trữ tài liệu có chứa virus phần mềm, worms
          (sâu), Trojan hoặc đoạn mã, các tập tin, tập lệnh, gián điệp hoặc chương trình máy tính
          đôc hại...
        </li>
        <li>
          Bồi thường thiệt hại cho Bên A trong trường hợp Bên B vi phạm các nghĩa vụ đã cam kết tại
          Hợp đồng này và gây thiệt hại cho Bên A;
        </li>
        <li>
          Thanh toán phí dịch vụ đầy đủ cho Bên A theo đúng thời hạn quy định tại Điều 2 của Hợp
          đồng này;
        </li>
        <li>
          Sau khi 2 bên đã ký kết Hợp đồng và Bên A bàn giao việc sử dụng Phần mềm cho Bên B, Bên B
          phải có trách nhiệm tự quản lý chặt chẽ các tài khoản đã được đăng ký theo Điều 1.2 của
          Hợp đồng này và không chuyển nhượng, chuyển giao tài khoản của mình cho Bên thứ 3 khác.
        </li>
        <li>
          Cam kết thực hiện đầy đủ và tuân thủ các quy định của Pháp luật Việt Nam về việc cung cấp
          hàng hóa, dịch vụ, bao gồm:
          <ul>
            <li>
              Phạm vi thực hiện cung cấp hàng hóa dịch vụ liên quan đến Hợp đồng này: trên lãnh thổ
              Việt Nam
            </li>
            <li>
              Đảm bảo hàng hóa có nguồn gốc xuất xứ rõ ràng; chính xác; phù hợp với sự mô tả trên
              bao bì, nhãn hiệu hàng hóa; đạt các yêu cầu về tiêu chuẩn của loại hàng hóa dịch vụ đó
              và phù hợp với mẫu mã hàng hóa đã quảng bá đến người mua.
            </li>
            <li>
              Chỉ lưu hành & cung cấp các loại hàng hóa dịch vụ được phép mua bán, trao đổi theo quy
              định của Pháp luật hiện hành
            </li>
          </ul>
        </li>
      </ul>
      <div class="dieukhoan">
        <label><b>ĐIỀU 5. CHẤM DỨT HỢP ĐỒNG</b> </label>
        <ul class="dk-list">
          <li>
            <span>5.1.</span> Hợp đồng này chấm dứt trong các trường hợp sau:<br />
            - Các Bên có thông báo và thoả thuận với nhau bằng văn bản/email về việc chấm dứt Hợp
            đồng;<br />
            - Xảy ra sự kiện bất khả kháng theo quy định của Điều 7 dưới đây, dẫn đến việc một Bên
            hoặc các Bên không thể tiếp tục thực hiện được Hợp Đồng và không thể khắc phục để tiếp
            tục thực hiện Hợp đồng;<br />
            - Một Bên hoặc các Bên bị tuyên bố phá sản hoặc giải thể;<br />
            - Các trường hợp khác được quy định tại Hợp đồng này.<br />
          </li>
          <li>
            <span>5.2.</span> Trước khi ký kết Biên bản thanh lý Hợp đồng, mọi nghĩa vụ tài chính
            giữa hai Bên phải được thực hiện đầy đủ theo quy định tại Hợp đồng.
          </li>
        </ul>
      </div>
      <div class="dieukhoan">
        <label><b>ĐIỀU 6. MIỄN TRỪ TRÁCH NHIỆM</b> </label>
        <p>Bên A được miễn trừ trách nhiệm trong các trường hợp sau:</p>
        <ul class="dk-list">
          <li><span>6.1</span> Có sự kiện bất khả kháng theo Điều 7 của Hợp đồng này;</li>
          <li>
            <span>6.2</span> Khi Bên A đã thông báo về thời gian nâng cấp, bảo trì Phần mềm mà Bên B
            vẫn thực hiện các công việc trên Phần mềm đó;
          </li>
          <li>
            <span>6.3</span> Các thiệt hại trực tiếp hoặc gián tiếp của Bên B do Bên B không kiểm
            soát bảo mật tài khoản và mật khẩu của Bên B trong Phần mềm;
          </li>
          <li>
            <span>6.4</span> Các thiệt hại trực tiếp hoặc gián tiếp của Bên B do lỗi thiết bị máy
            tính của Bên B hoặc đường truyền, hay các truy cập không được phép, virus, lỗi của nhà
            cung cấp dịch vụ đường truyền.
          </li>
          <li>
            <span>6.5</span> Các thiệt hại trực tiếp hoặc gián tiếp của Bên B do lỗi của các dịch vụ
            liên kết với Phần mềm được cung cấp bởi Bên thứ ba.
          </li>
        </ul>
      </div>
      <div class="dieukhoan">
        <label><b>ĐIỀU 7. TRƯỜNG HỢP BẤT KHẢ KHÁNG</b> </label>
        <ul class="dk-list">
          <li>
            <span>7.1</span> Sự kiện bất khả kháng là sự kiện xảy ra khách quan và nằm ngoài tầm
            kiểm soát của các Bên, có ảnh hưởng, tác động trực tiếp đến việc thực hiện quyền và
            nghĩa vụ của các Bên như thiên tai (động đất, lũ lụt, xoáy lốc, sóng thần), cháy nổ,
            chiến tranh hoặc có nguy cơ xảy ra chiến tranh và các thảm họa khác được coi là Sự kiện
            bất khả kháng hoặc sự thay đổi về chính sách, đường lối, pháp luật dẫn đến sự ngăn cấm,
            cản trở, hạn chế của cơ quan có thẩm quyền Việt Nam đối với hoạt động kinh doanh của Bên
            A hoặc bất cứ sự kiện nào theo quy định của pháp luật nằm ngoài nỗ lực kiểm soát Hợp lý
            của một trong hai bên dẫn đến những thiệt hại hoặc chậm trễ việc thực hiện hay không
            thực hiện Hợp đồng này (một phần hoặc toàn bộ);
          </li>
          <li>
            <span>7.2</span> Trong trường hợp bất khả kháng như vậy, Bên chịu tác động của Sự kiện
            bất khả kháng sẽ chủ động tiến hành các biện pháp ngăn ngừa, thay thế hợp lý và cần
            thiết để hạn chế kịp thời và tối đa những ảnh hưởng xấu của Sự kiện bất khả kháng. Đống
            thời, Bên chịu tác động có trách nhiệm thông báo ngay cho Bên kia biết về Sự kiện bất
            khả kháng này trong thời gian sớm nhất có thể để thống nhất sắp xếp cuộc họp trực tiếp
            hoặc thông qua bất kỳ phương tiện nào thích hợp để thảo luận về việc khắc phục sự kiện
            bất khả kháng hoặc đưa ra phương án giải quyết trong từng trường hợp bất khả kháng nêu
            trên;
          </li>
          <li>
            <span>7.3</span> Trong trường hợp xảy ra Sự kiện bất khả kháng, Bên chịu tác động đã
            tiến hành khắc phục nhưng không thể tiếp tục thực hiện Hợp đồng, hai bên sẽ chấm dứt Hợp
            đồng trước thời hạn theo Điều 5 của Hợp đồng này.
          </li>
          <li>
            <span>7.4</span> Những trường hợp bất khả kháng phải được chứng nhận bởi các cơ quan nhà
            nước có thẩm quyền tại khu vực xảy ra những sự kiện mà được viện dẫn là những trường hợp
            bất khả kháng, ngoại trừ khi trường hợp bất khả kháng là sự thật hiển nhiên đã hoặc đang
            diễn ra mà cả hai bên có thể chứng kiến.
          </li>
        </ul>
      </div>
      <div class="dieukhoan">
        <label><b>ĐIỀU 8. BẢN QUYỀN, BẢO MẬT THÔNG TIN</b> </label>
        <ul class="dk-list">
          <li>
            <span>8.1</span> Các Bên cam kết rằng bản quyền sở hữu trí tuệ của Phần mềm được nêu
            trong hợp đồng này thuộc về Bên A. Nếu Bên B có bất kỳ sự vi phạm về quyền sở hữu trí
            tuệ của Phần mềm này, Bên B sẽ phải bồi thường toàn bộ các thiệt hại cho Bên A;
          </li>
          <li>
            <span>8.2</span> Các Bên cam kết bảo mật các thông tin kinh doanh của Bên còn lại bao
            gồm hàng hóa, khách hàng, nhà cung cấp, bí mật công nghệ. Nếu Bên nào phát hiện (có
            chứng cứ) Bên còn lại vi phạm cam kết, Bên vi phạm sẽ phải bồi thường toàn bộ các thiệt
            hại phát sinh cho Bên bị vi phạm.
          </li>
        </ul>
      </div>
      <div class="dieukhoan">
        <label><b>ĐIỀU 9. GIẢI QUYẾT TRANH CHẤP </b></label>
        <p>
          Trong quá trình thực hiện Hợp đồng này, mọi tranh chấp phát sinh từ Hợp đồng này sẽ được
          giải quyết thông qua thương lượng và hòa giải. Trong trường hợp tranh chấp không thể giải
          quyết thì một trong hai bên sẽ có quyền đưa tranh chấp ra giải quyết tại Toà án nhân dân
          có thẩm quyền.
        </p>
      </div>
      <div class="dieukhoan">
        <label><b>ĐIỀU 10. ĐIỀU KHOẢN CHUNG</b> </label>
        <p>
          - Hợp đồng này có hiệu lực kể từ ngày ký;<br />
          - Nếu một bên có bất kỳ sự thay đổi nào trong quá trình thực hiện hợp đồng, phải có nghĩa
          vụ thông báo bằng văn bản, email hoặc các hình thức khác (được bên kia chấp nhận) với bên
          còn lại trước chậm nhất là 05 (năm) ngày kể từ ngày có sự thay đổi.<br />
          - Hợp đồng này được lập thành 02 (hai) bản bằng tiếng Việt có giá trị pháp lý như nhau,
          mỗi Bên giữ 01 (một) bản để thực hiện.
        </p>
      </div>
      <Footer :dataContract="dataContract" :isAppendix="false"></Footer>
      <div class="html2pdf__page-break2"></div>
    </div>
    <div class="contract" v-else>
      <Header :groupService="dataContract.groupService"></Header>
      <p class="txt-center fonsize-16 txt-tranf">
        <b>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM </b>
      </p>
      <p class="txt-center fonsize-16">
        <b>Độc lập – Tự do – Hạnh phúc</b>
      </p>
      <p class="txt-center fonsize-16">***</p>
      <p class="txt-tranf txt-center fonsize-20">
        <b
          >HỢP ĐỒNG HỢP TÁC<br />
          CHẤP NHẬN THANH TOÁN</b
        >
      </p>
      <p class="txt-center">
        (Số:
        <mark v-if="!isHiddenFilePdf">{{ dataContract.nganluongCode || dataAppendix?.code }}</mark>
        <span v-else>{{ dataAppendix?.appendixNganluongConvert?.nganluongContractCode }}</span
        >)
      </p>
      <h3>Căn cứ:</h3>
      <ul class="form-style">
        <li>
          Bộ Luật Dân sự được Quốc hội nước Cộng hòa xã hội chủ nghĩa Việt Nam thông qua ngày 24
          tháng 11 năm 2015, có hiệu lực từ ngày 01 tháng 01 năm 2017 và các văn bản hướng dẫn thi
          hành;
        </li>
        <li>
          Luật Thương mại được Quốc hội nước Cộng hòa xã hội chủ nghĩa Việt Nam thông qua ngày 14
          tháng 6 năm 2005, có hiệu lực từ ngày 01 tháng 01 năm 2006 và các văn bản hướng dẫn thi
          hành;
        </li>
        <li>
          Nghị định số 52/2024/NĐ-CP ngày 15 tháng 5 năm 2024 của Chính phủ quy định về thanh toán
          không dùng tiền mặt;
        </li>
        <li>
          Thông tư số 15/2024/TT-NHNN ngày 28 tháng 6 năm 2024 của Ngân hàng Nhà nước Việt Nam quy
          định về cung ứng dịch vụ thanh toán không dùng tiền mặt;
        </li>
        <li>
          Thông tư số 18/2024/TT-NHNN ngày 28 tháng 6 năm 2024 của Ngân hàng Nhà nước Việt Nam quy
          định về hoạt động thẻ ngân hàng;
        </li>
        <li>
          Thông tư số 40/2024/TT-NHNN ngày 17 tháng 7 năm 2024 của Ngân hàng Nhà nước Việt Nam quy
          định về hoạt động cung ứng dịch vụ trung gian thanh toán;
        </li>
        <li>Nhu cầu và khả năng của các Bên.</li>
      </ul>
      <p>
        Hôm nay, ngày
        <template v-if="isHiddenFilePdf">
          <mark v-if="dataAppendix?.dateSignAppendixDTO">{{
            dataAppendix.dateSignAppendixDTO | formatDate
          }}</mark>
          <mark v-else-if="dataAppendix?.dateCreatedAppendixDTO">{{
            dataAppendix.dateCreatedAppendixDTO | formatDate
          }}</mark>
          <mark v-else>{{ new Date() | formatDate }}</mark>
        </template>
        <template v-else>
          <mark v-if="dataAppendix?.isNganluongContract">
            {{ dataAppendix?.dateSignContract | formatDate }}</mark
          >
          <mark v-else>{{ dataContract.effectiveFromDTO | formatDate }}</mark>
        </template>
        , tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:
      </p>
      <p class="fonsize-16 txt-tranf">
        <b>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p><b>(sau đây được gọi là “BÊN A”)</b></p>
      <p>
        Địa chỉ: Tầng 3, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <p>Điện thoại: 1900-2079</p>
      <p>Mã số thuế: 0106001236</p>
      <p>Đại diện: <b>Ông NGUYỄN TIẾN LƯỢNG</b></p>
      <p>Chức vụ: <b>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b></p>
      <p>Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026</p>

      <p class="fonsize-16 txt-tranf flex">
        <span> <b>BÊN B:</b></span>
        <mark
          ><b>{{ customerInfo ? customerInfo.merchantName : '' }}</b></mark
        >
      </p>
      <p><b>(sau đây được gọi là “BÊN B”)</b></p>
      <div v-if="isHiddenFilePdf">
        <p>
          <span>Địa chỉ:</span>
          <mark>{{ customerInfo ? customerInfo.address : '' }} </mark>
        </p>

        <p>
          <span>Email:</span>
          <mark>
            {{ customerInfo ? customerInfo.email : '' }}
          </mark>
        </p>
        <p>
          <span>Điện thoại:</span>
          <mark>
            {{ customerInfo ? customerInfo.mobile : '' }}
          </mark>
        </p>
      </div>

      <p v-if="isHiddenFilePdf && customerInfo.businessRegistrationNumber">
        <span>Mã số thuê:</span>
        <mark>{{ customerInfo ? customerInfo.businessRegistrationNumber : '' }} </mark>
      </p>

      <p>
        <span v-if="isHiddenFilePdf">Đại diện </span>
        <span v-else> Họ và tên người đại diện theo pháp luật: </span>
        <mark
          ><b>{{ customerInfo ? customerInfo.customerName : '' }}</b></mark
        >
        <span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Chức vụ: </span>
        <mark
          ><b>{{
            customerInfo ? customerInfo.invoiceMcContactPosition : '......................'
          }}</b></mark
        >
      </p>
      <p>
        <span v-if="isHiddenFilePdf"> Số CMND/CCCD: </span>
        <span v-else>Số CMND/Hộ chiếu/Thẻ căn cước:</span>
        <mark>{{ customerInfo ? customerInfo.passport : '' }}</mark>
        <span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Nơi cấp:</span>
        <mark>{{ customerInfo ? customerInfo.placeOfIssue : '' }}</mark>
      </p>
      <p v-if="customerInfo && customerInfo.businessRegistrationNumber">
        <span>Mã số thuế doanh nghiệp/ Số đăng ký kinh doanh: </span>
        <mark>{{ customerInfo ? customerInfo.businessRegistrationNumber : '' }}</mark>
      </p>

      <p v-if="!isHiddenFilePdf">
        <span>Địa chỉ:</span>
        <mark
          >{{ customerInfo ? customerInfo.address : 'Không có' }}
          <!-- {{ customerInfo ? customerInfo.ward : "Không có" }},
          {{ customerInfo ? customerInfo.district : "Không có" }},
          {{ customerInfo ? customerInfo.city : "Không có" }} -->
        </mark>
      </p>
      <p>
        <span v-if="isHiddenFilePdf">SĐT:</span>
        <span v-else>Điện thoại:</span>
        <mark>
          {{
            customerInfo
              ? isHiddenFilePdf
                ? customerInfo.authoriserContactNumber
                : customerInfo.mobile
              : ''
          }}
        </mark>
        <span
          v-if="!(customerInfo && customerInfo.accIdType && customerInfo.accIdType === 'MOBILE')"
        >
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Email:
          <mark>
            {{
              customerInfo
                ? isHiddenFilePdf
                  ? customerInfo.authoriserEmail
                  : customerInfo.email
                : ''
            }}
          </mark></span
        >
      </p>
      <p>&nbsp;</p>
      <p>
        Sau khi xem xét các điều khoản và điều kiện của Hợp đồng, chúng tôi cùng đồng ý ký kết và
        thực hiện các điều khoản dưới đây:
      </p>
      <ol class="form-style1">
        <li>
          <h1>nội dung hợp tác</h1>
          <p>
            Bên A là một pháp nhân hoạt động hợp pháp trong lĩnh vực Trung gian thanh toán đã được
            Ngân hàng Nhà nước Việt Nam cấp giấy phép hoạt động số 22/GP-NHNN, ngày 10/02/2017; bằng
            năng lực của mình, thực hiện việc cung cấp dịch vụ chấp nhận thanh toán thẻ và QRCode
            cho Khách hàng dưới các điều khoản và điều kiện trong Hợp đồng này.
          </p>
          <p>
            Bên B là một hộ kinh doanh hoặc doanh nghiệp hoạt động hợp pháp trong lĩnh vực
            <mark>{{
              customerInfo ? customerInfo.mcc : '' | transfromMccName(dataConfigMcc)
            }}</mark>
            hiểu và đồng ý các điều khoản và điều kiện cho việc chấp thuận sử dụng dịch vụ của Bên A
            cung cấp trên tinh thần thiện chí hợp tác, tự nguyện, cùng có lợi.
          </p>
          <p>
            Vì vậy, các bên thống nhất ký kết hợp đồng này với phạm vi công việc và mục đích sau:
          </p>
          <ul class="form-style">
            <li v-if="isHiddenFilePdf">
              Hợp đồng này quy định quyền lợi và trách nhiệm của các Bên trong việc ký kết và thực
              hiện
              <b>“Hợp đồng hợp tác chấp nhận thanh toán”</b>
              (viết tắt là <b>“Hợp đồng”</b>), bao gồm cả các Phụ lục Hợp đồng, cho phép Khách hàng
              có thể sử dụng thẻ thanh toán mang thương hiệu Visa, Master Card hoặc JCB, CUP, Amex,
              DCI; các loại thẻ ATM (thẻ Napas) do các ngân hàng tại Việt Nam phát hành; QRCode do
              ngân hàng và các ví điện tử cung cấp để thanh toán tiền hàng hoá, dịch vụ.
            </li>
            <li v-if="!isHiddenFilePdf">
              Hợp đồng này quy định quyền lợi và trách nhiệm của các Bên trong việc ký kết và thực
              hiện
              <b>“Hợp đồng hợp tác chấp nhận thanh toán”</b>
              (viết tắt là <b>“Hợp đồng”</b>), cho phép Khách hàng có thể sử dụng thẻ thanh toán
              mang thương hiệu Visa, Master Card hoặc JCB, CUP, Amex, DCI; các loại thẻ ATM, thẻ
              Napas do các ngân hàng tại Việt Nam phát hành; QRCode do ngân hàng và các ví điện tử
              cung cấp để thanh toán tiền hàng hoá, dịch vụ.
            </li>
            <li>
              Bên B đồng ý sử dụng dịch vụ của Bên A theo các Điều khoản được quy định trong nội
              dung Hợp đồng này cùng các Phụ lục hợp đồng kèm theo.
            </li>
          </ul>
        </li>
        <li>
          <h1>PHÍ GIAO DỊCH</h1>
          <ol>
            <li>
              <span class="txt-bold"> Mức phí giao dịch</span>
              <ul>
                <li>
                  Mức phí giao dịch được quy định chi tiết trong Phụ lục đính kèm Hợp đồng này.
                </li>
                <li>
                  Khi có sự thay đổi về chính sách phí áp dụng; Bên A sẽ tiến hành gửi Công văn
                  thông báo đến Bên B qua email Bên B đã đăng ký tài khoản trên hệ thống của Bên A.
                  Công văn thông báo này có giá trị pháp lý như một phần không tách rời khỏi Hợp
                  đồng Hợp tác Chấp nhận thanh toán đã ký giữa Bên A & Bên B.
                </li>
              </ul>
            </li>
            <li>
              <span class="txt-bold">Cơ sở tính phí và hình thức thanh toán phí</span>
              <ul>
                <li>
                  Phí được tính toán theo từng giao dịch trên hệ thống của Bên A, căn cứ trên số
                  lượng và tổng số tiền Giao dịch thành công.
                </li>
                <li>
                  Phí giao dịch được khấu trừ trực tiếp trên tổng số tiền Bên A thanh toán cho Bên B
                  theo chu kỳ được quy định tại Điều 4 của Hợp đồng này.
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>THÔNG TIN TÀI KHOẢN VÀ ĐẦU MỐI LIÊN HỆ</h1>
          <ol>
            <li>
              <span class="txt-bold">Thông tin đăng ký tài khoản</span>
              <ul>
                <p>
                  - Bên B đồng ý sử dụng các thông tin sau để đăng ký tài khoản trên hệ thống thanh
                  toán của Bên A:
                </p>
                <table>
                  <tr>
                    <td style="border-top: 1px">Email đăng ký mở tài khoản (bắt buộc)</td>
                    <td style="border-top: 1px">
                      <span
                        v-if="
                          !(
                            customerInfo &&
                            customerInfo.accIdType &&
                            customerInfo.accIdType === 'MOBILE'
                          )
                        "
                        >{{ customerInfo ? customerInfo.email : '' }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>SĐT đăng ký mở tài khoản (bắt buộc)</td>
                    <td>
                      {{ customerInfo ? customerInfo.mobile : '' }}
                    </td>
                  </tr>
                  <tr>
                    <td>Địa chỉ trụ sở trên đăng ký kinh doanh (bắt buộc)</td>
                    <td>
                      {{ customerInfo ? customerInfo.address : 'Không có' }}
                      <!-- {{ customerInfo ? customerInfo.district : "Không có" }},
                      {{ customerInfo ? customerInfo.city : "Không có" }} -->
                    </td>
                  </tr>
                  <tr>
                    <td>Số Đăng ký Kinh doanh (bắt buộc)</td>
                    <td>
                      {{ customerInfo ? customerInfo.businessRegistrationNumber : '' }}
                    </td>
                  </tr>
                  <tr v-if="isHiddenFilePdf">
                    <td>Thông tin xuất hóa đơn</td>
                    <td>
                      <p>
                        Tên công ty/hộ kinh doanh::
                        {{
                          dataAppendix ? dataAppendix?.appendixNganluongConvert?.invoiceMcName : ''
                        }}
                      </p>
                      <p>
                        Địa chỉ:
                        {{
                          dataAppendix
                            ? dataAppendix?.appendixNganluongConvert?.invoiceMcAddress
                            : ''
                        }}
                      </p>
                      <p>
                        Mã số thuế:
                        {{
                          dataAppendix
                            ? dataAppendix?.appendixNganluongConvert?.invoiceMcBusinessNumber
                            : ''
                        }}
                      </p>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      customerInfo.enableSendMonthlyReport &&
                      customerInfo.enableSendMonthlyReport === true &&
                      !isHiddenFilePdf
                    "
                  >
                    <td>Thông tin xuất hóa đơn</td>
                    <td>
                      <p>
                        Tên công ty/hộ kinh doanh::
                        {{ customerInfo ? customerInfo.invoiceMcName : '' }}
                      </p>
                      <p>Địa chỉ: {{ customerInfo ? customerInfo.invoiceMcAddress : '' }}</p>
                      <p>
                        Mã số thuế: {{ customerInfo ? customerInfo.invoiceMcBusinessNumber : '' }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>Thông tin người đại diện ký hợp đồng với Ngân Lượng (Bắt buộc)</td>
                    <td>
                      <p>Họ tên: {{ customerInfo ? customerInfo.customerName : '' }}</p>
                      <p>Chức vụ: {{ customerInfo ? customerInfo.position : '' }}</p>
                      <p>Email: {{ customerInfo ? customerInfo.email : '' }}</p>
                      <p>SĐT: {{ customerInfo ? customerInfo.mobile : '' }}</p>
                      <p>Số CCCD/CMT: {{ customerInfo ? customerInfo.passport : '' }}</p>
                    </td>
                  </tr>
                </table>
              </ul>
            </li>
            <li>
              <span class="txt-bold">Thông tin đầu mối liên hệ</span>
              <ul class="">
                <table width="100%">
                  <thead class="thead-light">
                    <tr>
                      <th scope="cul" class="text-left"></th>
                      <th scope="cul" class="text-center">Bên A</th>
                      <th scope="cul" class="text-center">Bên B</th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, i) in mergedData" :key="i">
                    <tr class="table-row">
                      <td class="text-left">{{ item.name }}</td>
                      <td class="text-left">
                        <p v-if="item.emailAside">Email: {{ item.emailAside }}</p>
                        <p v-if="item.mobileAside">Hotline: {{ item.mobileAside }}</p>
                      </td>
                      <td class="text-left">
                        <p v-if="item.email">Email: {{ item.email }}</p>
                        <p v-if="item.mobile">Hotline: {{ item.mobile }}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>ĐỐI SOÁT VÀ THANH QUYẾT TOÁN</h1>
          <ol>
            <li>
              <span class="txt-bold">Nguyên tắc thanh toán</span>
              <ul>
                <li>Đồng tiền thanh toán là tiền Việt Nam (VNĐ)</li>
                <li>
                  <p>
                    Gọi ngày giao dịch là T, vào
                    <b>Ngày làm việc</b> [<b class="clred">T+1</b>] (<i
                      >là ngày theo Dương lịch, không bao gồm các ngày thứ Bảy, Chủ nhật và các ngày
                      nghỉ lễ theo quy định pháp luật của Việt Nam</i
                    >), Bên A tiến hành thanh toán cho Bên B số tiền theo nguyên tắc như sau:
                  </p>
                  <p>
                    <b>Số tiền thanh toán</b> = [<b>Tổng tiền Giao dịch thành công</b>] – [<b
                      >Tổng phí Giao dịch</b
                    >] – [<b>Tổng tiền Giao dịch hoàn trả </b><i>(nếu có)</i>].
                  </p>
                </li>
                <li>Phí chuyển tiền do ngân hàng của Bên A thu (nếu có), do Bên A chi trả.</li>
                <li>Phí nhận tiền do ngân hàng của Bên B thu (nếu có), do Bên B chi trả.</li>
                <li>
                  Bên A thanh toán cho Bên B số tiền của các giao dịch từ 3.000 VNĐ (Ba nghìn Việt
                  Nam Đồng)/ giao dịch trở lên và số tiền tối thiểu Bên A thanh toán cho BÊN B là
                  100.000 VNĐ (Một trăm nghìn Việt Nam Đồng) trong mỗi lần thanh toán. Riêng kênh QR
                  Code VietQR, số tiền giao dịch tối thiểu được chấp nhận và thanh toán qua hệ thống
                  Bên A là 1.000 VNĐ (Một nghìn Việt Nam Đồng) và số tiền tối thiểu Bên A thanh toán
                  cho BÊN B là 50.000 VNĐ (Năm mươi nghìn Việt Nam Đồng) cho mỗi lần thanh toán.
                </li>
              </ul>
            </li>
            <li>
              <span class="txt-bold">Hình thức thanh toán</span>
              <ul>
                <li>
                  Bên A thanh toán bằng hình thức chuyển khoản qua ngân hàng tới số tài khoản ngân
                  hàng của Bên B theo thông tin như sau:
                </li>
                <table>
                  <tr>
                    <td style="border-top: 1px">Loại tài khoản</td>
                    <td style="border-top: 1px">VND</td>
                  </tr>
                  <tr>
                    <td>Tên người thụ hưởng</td>
                    <td>
                      {{ customerInfo ? customerInfo.holderName : '' }}
                    </td>
                  </tr>
                  <tr>
                    <td>Số tài khoản ngân hàng</td>
                    <td>
                      {{ customerInfo ? customerInfo.accountNo : '' }}
                    </td>
                  </tr>
                  <tr>
                    <td>Tại ngân hàng</td>
                    <td>
                      {{ customerInfo ? customerInfo.bankName : '' }}
                    </td>
                  </tr>
                  <!-- <tr>
                    <td>Chi nhánh ngân hàng</td>
                    <td>
                      {{ customerInfo ? customerInfo.branch : '' }}
                    </td>
                  </tr>
                  <tr>
                    <td>Tại Tỉnh/ Thành phố</td>
                    <td>
                      {{ customerInfo ? customerInfo.bankCityName : '' }}
                    </td>
                  </tr> -->
                </table>

                <li>
                  Khi Bên B có nhu cầu thay đổi tài khoản ngân hàng, hai Bên cần xác nhận bằng văn
                  bản hoặc thông báo từ Bên B bằng email đã đăng ký trên hệ thống của Bên A.
                </li>
              </ul>
            </li>
            <li
              v-if="
                customerInfo.enableSendMonthlyReport &&
                customerInfo.enableSendMonthlyReport === true
              "
            >
              <span class="txt-bold">Đối soát và xuất hóa đơn giá trị gia tăng</span>
              <div>
                Hàng tháng Bên A gửi Bên B file đối soát giao dịch từ 00h00’ ngày 22 tháng trước đến
                23h59’ ngày 21 của tháng đối soát để hai bên đối soát dữ liệu. Trong vòng 03 (ba)
                ngày làm việc (là ngày dương lịch, không bao gồm các ngày thứ Bảy, Chủ nhật và các
                ngày nghỉ lễ theo quy định của pháp luật Việt Nam), nếu Bên B không có phản hồi về
                đối soát, Bên A sẽ ghi nhận số liệu và xuất hóa đơn giá trị gia tăng phần phí mà Bên
                A thu của Bên B.
              </div>
            </li>
          </ol>
        </li>
        <li>
          <h1>DANH SÁCH ĐIỂM CHẤP NHẬN THANH TOÁN CỦA BÊN B</h1>
          <div class="p-4 w-100" style="overflow-x: auto">
            <table style="display: table !important; width: 100% !important">
              <thead class="w-100">
                <tr>
                  <th scope="col" class="text-left">Tên điểm chấp nhận</th>
                  <th scope="col" class="text-left">Địa chỉ</th>
                </tr>
              </thead>
              <tbody
                v-for="(item, index) in dataContract?.merchantBusinessAreas ||
                dataContract?.customerInfoCommon?.merchantBusinessAreas"
                :key="index"
              >
                <tr class="table-row">
                  <td class="text-left">{{ item.areaName }}</td>
                  <td align="left">
                    {{ item.areaAddress }}
                    <!-- <span v-show="item.areaDistrict">
                      - {{ item.areaDistrict }}</span>
                    <span v-show="item.areaCity"> - {{ item.areaCity }}</span> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          <h1>QUYỀN VÀ TRÁCH NHIỆM CỦA BÊN A</h1>
          <ol>
            <li>
              <span class="txt-bold">Quyền của Bên A</span>
              <ul>
                <li>Được hưởng phí giao dịch quy định tại Điều 2 của Hợp đồng này.</li>
                <li>
                  Được quyền tạm dừng thanh toán cho Bên B cho đến khi Bên B cung cấp đầy đủ các
                  chứng từ mua bán hàng hóa, cung ứng dịch vụ và được xác minh là hợp pháp, hợp lệ
                  bởi (các) bên có thẩm quyền (Tổ chức thẻ, Ngân hàng thanh toán, Bên A,...) đối với
                  các giao dịch nghi ngờ gian lận, giả mạo, giao dịch thanh toán khống (không phát
                  sinh việc mua bán hàng hóa và cung ứng dịch vụ); giao dịch nghi ngờ liên quan đến
                  hoạt động rửa tiền, tài trợ khủng bố, tài trợ phổ biến vũ khí hủy diệt hàng loạt,
                  vi phạm pháp luật; hoặc giao dịch tra soát (là các giao dịch có khiếu nại của Chủ
                  thẻ hoặc do Ngân hàng xử lý giao dịch yêu cầu tra soát); bao gồm nhưng không giới
                  hạn: các giao dịch nghi ngờ có giá trị bất thường so với ngành hàng của Bên B,
                  giao dịch thực hiện liên tiếp bất thường, giao dịch thẻ do Ngân hàng nước ngoài
                  phát hành có yếu tố nghi ngờ tương tự, các giao dịch có dấu hiệu đáng ngờ theo quy
                  định của pháp luật về phòng, chống rửa tiền và tài trợ khủng bố, tài trợ phổ biến
                  vũ khí hủy diệt hàng loạt.
                </li>
                <li>
                  Từ chối thanh toán hoặc truy đòi một phần/toàn bộ các khoản đã thanh toán cho Bên
                  B đối với các giao dịch thuộc một trong các trường hợp sau:
                  <br />
                  (i) Bên B có hành vi hoặc tạo điều kiện để thực hiện hành vi gian lận, không thực
                  hiện theo đúng hướng dẫn và quy định tại Hợp đồng này hoặc tại các quy định của
                  Bên A đã được thông báo bằng văn bản hoặc trên ứng dụng của Bên A cung cấp cho Bên
                  B trong quá trình sử dụng dịch vụ;
                  <br />
                  (ii) Ngân hàng thanh toán, Tổ chức thẻ, đơn vị cung ứng dịch vụ thanh toán yêu cầu
                  kiểm tra, tra soát Bên B hoặc các giao dịch của Bên B;
                  <br />
                  (iii) Các giao dịch bị Chủ thẻ khiếu kiện, khiếu nại.
                </li>
                <li>
                  Phối hợp với Bên B để tra soát và hoàn tiền cho các giao dịch mà Khách hàng đã trừ
                  tiền trên thẻ/ tài khoản nhưng chưa được hệ thống của Bên A ghi nhận thành công
                  cho Bên B hoặc Bên B có nhu cầu hoàn lại tiền cho Khách hàng khi Khách hàng huỷ
                  đơn hàng.
                </li>
                <li>
                  Được quyền từ chối và/ hoặc tạm dừng việc thực hiện nghĩa vụ thanh toán của Bên A
                  trong trường hợp Bên B vi phạm bất kỳ nghĩa vụ thanh toán nào đã được quy định
                  trong Hợp đồng này.
                </li>
                <li>
                  Được quyền kiểm tra, kiểm soát và tạm dừng ghi nhận giao dịch đối với các giao
                  dịch mà Bên A nghi ngờ có sự gian lận của Chủ thẻ/Chủ tài khoản hoặc Bên B; từ
                  chối ghi nhận giao dịch đối với các giao dịch phát hiện có sự gian lận của Chủ
                  thẻ/Chủ tài khoản hoặc Bên B. Tùy từng trường hợp vi phạm, Bên A sẽ thông báo bằng
                  văn bản đến Bên B.
                </li>
                <li>
                  Bên A được quyền kiểm tra thực tế điểm chấp nhận thanh toán của Bên B để đánh giá
                  về tính phù hợp của giấy tờ chứng minh loại hình kinh doanh, việc tuân thủ các quy
                  định tại Hợp đồng và hướng dẫn của Bên A.
                </li>
                <li>
                  Bên A được quyền nêu tên Bên B theo quy định của pháp luật trong các chiến dịch
                  quảng bá chương trình có nội dung phù hợp với loại hình kinh doanh của Bên B mà
                  Bên A có thể sẽ thực hiện trong thời hạn của Hợp đồng này.
                </li>
                <li>
                  Từ chối thực hiện quảng cáo cho Bên B nếu Bên B không tuân thủ các quy định tại
                  Hợp đồng này hoặc vi phạm các quy định của pháp luật.
                </li>
                <li>
                  Chấm dứt Hợp đồng và ngừng cung cấp dịch vụ chấp nhận thanh toán trên hệ thống của
                  Bên A nếu Bên B có hành vi gian lận (như tự ý sao chép thông tin thẻ/ tài khoản
                  của Khách hàng) hoặc không tuân thủ các quy định liên quan đến giao dịch thanh
                  toán được quy định tại Hợp đồng này và các Phụ lục kèm theo hoặc đã được Bên A
                  hướng dẫn.
                </li>
              </ul>
            </li>
            <li>
              <span class="txt-bold"> Trách nhiệm của Bên A</span>
              <ul>
                <li>
                  Đảm bảo bí mật các thông tin về Bên B, chỉ được phép tiết lộ thông tin khi có yêu
                  cầu của cơ quan chức năng theo quy định của pháp luật hoặc theo yêu cầu của Hợp
                  đồng này. Bên A phải thông báo cho Bên B biết nội dung đã tiết lộ, trừ khi pháp
                  luật hoặc Hợp đồng này có quy định khác.
                </li>
                <li>
                  Thanh toán đầy đủ, đúng hạn các giao dịch hợp lệ phát sinh theo Điều 4 Hợp đồng
                  này, trừ trường hợp Hợp đồng này có quy định khác.
                </li>
                <li>Giải quyết các yêu cầu tra soát, khiếu nại của Bên B.</li>
                <li>
                  Bên A hoàn toàn không chịu trách nhiệm đối với những tranh chấp liên quan đến các
                  điều khoản và điều kiện được thỏa thuận, ký kết giữa Bên B và Khách hàng của Bên
                  B.
                </li>
                <li>
                  Lên kế hoạch và thông báo cho Bên B về lịch trình kiểm tra/ bảo trì thiết bị định
                  kỳ tại các điểm chấp nhận thanh toán của Bên B.
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>QUYỀN VÀ TRÁCH NHIỆM CỦA BÊN B</h1>
          <ol>
            <li>
              <span class="txt-bold">Quyền của Bên B</span>
              <ul>
                <li>
                  Được sử dụng Dịch vụ thanh toán thẻ/ QRCode trên ứng dụng của Bên A để Khách hàng
                  có thể thực hiện thanh toán tiền hàng hoá, dịch vụ cho Bên B.
                </li>
                <li>
                  Được Bên A thanh toán giá trị giao dịch (sau khi đã trừ phí) đầy đủ và đúng hạn
                  cho những giao dịch Khách hàng đã thanh toán bằng thẻ/ QRCode và được ghi nhận
                  thành công trên hệ thống của Bên A theo quy định trong Điều 4 của Hợp đồng này,
                  trừ trường hợp Hợp đồng này có quy định khác.
                </li>
                <li>
                  Được quyền yêu cầu Bên A phối hợp và hỗ trợ xử lý những sai sót xảy ra trong quá
                  trình giao dịch trên hệ thống của Bên A cung cấp.
                </li>
              </ul>
            </li>
            <li>
              <span class="txt-bold">Trách nhiệm của Bên B</span>
              <ul>
                <li>
                  Thanh toán phí giao dịch cho Bên A theo quy định tại Điều 2 của Hợp đồng này.
                </li>
                <li>
                  Cam kết chỉ chấp nhận các giao dịch thanh toán được thực hiện tại điểm chấp nhận
                  thanh toán của Bên B đã đăng ký với Bên A và trên phạm vi lãnh thổ Việt Nam.
                </li>
                <li>
                  Phối hợp với Bên A thiết lập và duy trì Dịch vụ thanh toán do Bên A cung cấp.
                </li>
                <li>
                  Bên B chịu trách nhiệm giải quyết trực tiếp với Khách hàng trong tất cả các trường
                  hợp phát sinh tranh chấp, khiếu nại, khiếu kiện liên quan đến việc thực hiện giao
                  dịch và việc thực hiện các nghĩa vụ của Bên B theo thỏa thuận mua bán hàng hóa,
                  cung cấp dịch vụ được thỏa thuận giữa Bên B và Khách hàng.
                </li>
                <li>
                  Bên B cam kết miễn trừ cho Bên A toàn bộ trách nhiệm phát sinh từ/hoặc liên quan
                  đến các yêu cầu, khiếu nại, tranh chấp, đề xuất, ràng buộc, quyết định thi hành
                  bởi Bên Thứ Ba đối với các thiệt hại, phạt, nghĩa vụ tài chính thuộc phạm vi hợp
                  tác của Hợp đồng và Phụ lục này do lỗi của bên B gây ra. Đồng thời, bồi thường
                  toàn bộ thiệt hại trực tiếp (nếu có) cho Bên A trong trường hợp Bên A phải gánh
                  chịu các thiệt hại phát sinh từ Hợp đồng này mà không do lỗi Bên A gây ra và do
                  lỗi của bên B gây ra.
                </li>
                <li v-if="isHiddenFilePdf">
                  Có trách nhiệm xuất chứng từ hoặc hóa đơn bán hàng hoá, dịch vụ hợp lệ cho Khách
                  hàng tương ứng với khoản tiền đã thanh toán cho hàng hoá, dịch vụ do Bên B cung
                  ứng.
                </li>
                <li v-if="isHiddenFilePdf">
                  Bên B có trách nhiệm cung cấp chứng từ theo quy định tại điểm h khoản 7.2 Điều 7
                  Hợp đồng này cho Bên A trong thời gian không quá 03 (ba) ngày kể từ ngày nhận được
                  yêu cầu của Bên A.
                </li>
                <li v-if="isHiddenFilePdf">
                  Để hỗ trợ và bảo vệ Bên B khi xảy ra các tranh chấp, khiếu nại, tra soát, rủi
                  ro,... Bên B có trách nhiệm phối hợp với Bên A cung cấp các chứng từ giao dịch.
                  Chứng từ giao dịch là những chứng từ mà Bên B phải cung cấp cho Bên A khi phát
                  sinh yêu cầu cung cấp, bao gồm nhưng không giới hạn:
                  <ol>
                    <li>Hình ảnh CMND/CCCD/Hộ chiếu của Khách hàng;</li>
                    <li>
                      Hình ảnh camera kèm ngày tháng về quá trình thực hiện giao dịch thanh toán
                      giữa Bên B với Khách hàng;
                    </li>
                    <li>
                      Hóa đơn cung cấp hàng hóa, dịch vụ của Bên B và Khách hàng (Hoá đơn bán hàng,
                      phiếu xuất kho, hoá đơn VAT,...);
                    </li>
                    <li>Các chứng từ và tài liệu liên quan khác theo yêu cầu của Bên A.</li>
                  </ol>
                </li>
                <li>
                  Bên B có trách nhiệm lưu trữ các chứng từ liên quan đến giao dịch cung ứng hàng
                  hoá, dịch vụ cho Khách hàng/Chủ thẻ/Chủ tài khoản trong thời gian 540 (năm trăm
                  bốn mươi) ngày kể từ ngày giao dịch phát sinh hoặc thời gian lâu hơn theo yêu cầu
                  của pháp luật hoặc được Bên A thông báo.
                </li>
                <li>
                  Sau thời hạn Bên A thông báo tới Bên B các giao dịch tra soát, khiếu nại, tranh
                  chấp, khiếu kiện, rủi ro liên quan,... (gọi chung là “khiếu nại”); Bên B đã nhận
                  được thông báo của Bên A nhưng không phản hồi, Bên A không liên hệ được với Bên B
                  bằng email hoặc số điện thoại Bên B đã đăng ký với Bên A, Bên B không còn kinh
                  doanh tại điểm chấp nhận thanh toán đã đăng ký với Bên A, chứng từ Bên B cung cấp
                  không đủ điều kiện để giải quyết giao dịch khiếu nại, Bên B chậm trễ xuất trình
                  chứng từ để giải quyết khiếu nại hoặc vì bất kỳ lý do nào khác cản trở việc giải
                  quyết khiếu nại,... do lỗi của Bên B và Bên B vi phạm nghĩa vụ cung cấp chứng từ
                  theo quy định của Hợp đồng, thì Bên B có trách nhiệm:
                  <p>
                    (i) Nếu số tiền Bên A tạm giữ không đủ để thực hiện hoàn trả/bồi hoàn cho Khách
                    hàng/Chủ thẻ/Chủ tài khoản, Bên B có trách nhiệm thanh toán bổ sung số tiền còn
                    thiếu theo thông báo của Bên A bằng hình thức thực hiện giao dịch tiếp theo
                    (quẹt thẻ, MO/TO, giao dịch linkcard, QR…) hoặc chuyển khoản về tài khoản ngân
                    hàng của Bên A để Bên A thực hiện hoàn trả giao dịch bị khiếu nại với các chi
                    phí và tổn thất phát sinh (nếu có) cho Khách hàng/Chủ thẻ/Chủ tài khoản.
                  </p>
                  <p>
                    (ii) Nếu trường hợp giao dịch khiếu nại đã được Bên A thanh toán cho Bên B, thì
                    Bên B có trách nhiệm thanh toán toàn bộ giá trị giao dịch và phí phát sinh (nếu
                    có) cho Bên A
                  </p>
                </li>
                <li>
                  Không được phép tăng giá bán và không được phép thu thêm các khoản phí xử lý thanh
                  toán hoặc áp dụng các chính sách tạo nên sự phân biệt đối xử giữa hình thức thanh
                  toán thẻ/ QRCode so với các hình thức thanh toán khác.
                </li>
                <li>
                  Thực hiện niêm yết công khai về việc không phân biệt giá hoặc thu thêm tiền, phụ
                  phí đối với các giao dịch thanh toán tiền hàng hóa, dịch vụ bằng thẻ/QR Code so
                  với các hình thức thanh toán khác.
                </li>
                <li>
                  Bên B không được chia tách giá trị của bất kỳ một giao dịch nào thành hai hay
                  nhiều giao dịch nhỏ hơn tại cùng một thời điểm.
                </li>
                <li v-if="isHiddenFilePdf">
                  Bên B không sử dụng thẻ phát hành dưới tên của mình hoặc phát hành dưới tên của cá
                  nhân là người đại diện theo pháp luật thể hiện trên Giấy chứng nhận đăng ký doanh
                  nghiệp/Hộ kinh doanh hoặc của vợ/chồng (khi Bên B là một Doanh nghiệp tư nhân hoặc
                  một hộ Kinh doanh cá thể) hoặc của giám đốc, thành viên hội đồng quản trị/hội đồng
                  thành viên, chủ tịch Công ty, kế toán trưởng hoặc thư ký (khi Bên B là một Công
                  ty) trong bất kỳ một giao dịch nào thực hiện trên thiết bị chấp nhận thanh toán
                  thẻ được cung cấp kèm theo Hợp đồng.
                </li>
                <li v-if="!isHiddenFilePdf">
                  Để hỗ trợ và bảo vệ bên B khi xảy ra các tranh chấp, khiếu nại, rủi ro,... Bên B
                  có trách nhiệm phối hợp với Bên A cung cấp các chứng từ giao dịch. Chứng từ giao
                  dịch là những chứng từ mà Bên B phải cung cấp cho Bên A khi phát sinh yêu cầu cung
                  cấp, bao gồm nhưng không giới hạn:
                  <ol>
                    <li>Hình ảnh CMND/CCCD/Hộ chiếu của Khách hàng;</li>
                    <li>
                      Hình ảnh camera kèm ngày tháng về quá trình thực hiện giao dịch thanh toán
                      giữa Bên B với Khách hàng;
                    </li>
                    <li>
                      Hóa đơn cung cấp hàng hóa, dịch vụ của Bên B và Khách hàng (Hoá đơn bán hàng,
                      phiếu xuất kho, hoá đơn VAT,...);
                    </li>
                    <li>
                      Các chứng từ và tài liệu liên quan khác theo yêu cầu của Bên A.
                      <ol>
                        <li>
                          Bên B có trách nhiệm lưu trữ các chứng từ liên quan đến giao dịch cung ứng
                          hàng hoá, dịch vụ cho Khách hàng/Chủ thẻ/Chủ tài khoản trong thời gian 540
                          (năm trăm bốn mươi) ngày kể từ ngày giao dịch phát sinh hoặc thời gian lâu
                          hơn theo yêu cầu của pháp luật hoặc được Bên A thông báo.
                        </li>
                        <li>
                          Sau thời hạn Bên A thông báo tới Bên B các giao dịch tra soát, khiếu nại,
                          tranh chấp, khiếu kiện, rủi ro liên quan,... (gọi chung là "khiếu nại");
                          Bên B đã nhận được thông báo của Bên A nhưng không phản hồi, Bên A không
                          liên hệ được với Bên B bằng email hoặc số điện thoại Bên B đã đăng ký với
                          Bên A, Bên B không còn kinh doanh tại điểm chấp nhận thanh toán đã đăng ký
                          với Bên A, chứng từ Bên B cung cấp không đủ điều kiện để giải quyết giao
                          dịch khiếu nại, Bên B chậm trễ xuất trình chứng từ để giải quyết khiếu nại
                          hoặc vì bất kỳ lý do nào khác cản trở việc giải quyết khiếu nại,... do lỗi
                          của Bên B và Bên B vi phạm nghĩa vụ cung cấp chứng từ theo quy định của
                          Hợp đồng, thì Bên B có trách nhiệm:
                          <br />
                          (i) Nếu số tiền Bên A tạm giữ không đủ để thực hiện hoàn trả/bồi hoàn cho
                          Khách hàng/Chủ thẻ/Chủ tài khoản, Bên B có trách nhiệm thanh toán bổ sung
                          số tiền còn thiếu theo thông báo của Bên A bằng hình thức thực hiện giao
                          dịch tiếp theo (quẹt thẻ, MO/TO, giao dịch linkcard, QR...) hoặc chuyển
                          khoản về tài khoản ngân hàng của Bên A để Bên A thực hiện hoàn trả giao
                          dịch bị khiếu nại với các chi phí và tổn thất phát sinh (nếu có) cho Khách
                          hàng/Chủ thẻ/Chủ tài khoản.
                          <br />
                          Nếu trường hợp giao dịch khiếu nại đã được Bên A thanh toán cho Bên B, thì
                          Bên B có trách nhiệm thanh toán toàn bộ giá trị giao dịch và phí phát sinh
                          (nếu có) cho Bên A.
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
                <li v-if="!isHiddenFilePdf">
                  Bên B có trách nhiệm lưu trữ các chứng từ liên quan đến hàng hoá, dịch vụ của
                  khách hàng/ chủ thẻ trong thời gian 540 (năm trăm bốn mươi) ngày kể từ ngày giao
                  dịch phát sinh.
                </li>

                <li>
                  Tham gia các buổi đào tạo, hướng dẫn dịch vụ thanh toán do Bên A tổ chức tại Bên A
                  hoặc điểm chấp nhận thanh toán của Bên B.
                </li>
                <li>
                  Xây dựng đội ngũ nhân sự và các quy trình nghiệp vụ cần thiết để hai Bên triển
                  khai Dịch vụ thanh toán do Bên A cung cấp cho việc phát triển kinh doanh của Bên
                  B.
                </li>
                <li>
                  Áp dụng các biện pháp nghiệp vụ để đảm bảo an toàn số liệu và chịu trách nhiệm bảo
                  mật hệ thống của mình để tránh hiện tượng truy cập trái phép vào mạng lưới của một
                  Bên thông qua hệ thống của Bên kia và ngược lại.
                </li>
                <li>
                  Phối hợp với Bên A đối soát và chốt số liệu giao dịch thanh toán thông qua Dịch vụ
                  thanh toán do Bên A cung cấp định kỳ hàng tháng trên hệ thống của Bên A cung cấp.
                </li>

                <li v-if="!isHiddenFilePdf">
                  Có trách nhiệm xuất chứng từ hoặc hóa đơn bán hàng hoá, dịch vụ hợp lệ cho Khách
                  hàng tương ứng với khoản tiền đã thanh toán cho hàng hoá, dịch vụ do Bên B cung
                  ứng.
                </li>
                <li>
                  Bên B có trách nhiệm cung cấp đầy đủ, chính xác thông tin của Bên B, khách hàng
                  giao dịch và chứng từ giao dịch tại Bên B theo yêu cầu của Bên A hoặc Ngân hàng,
                  Tổ chức thẻ hoặc Cơ quan chức năng để phục vụ việc điều tra hoạt động rửa tiền,
                  tài trợ khủng bố, tài trợ phổ biến vũ khí hủy diệt hàng loạt hoặc gửi cho cơ quan
                  có thẩm quyền khi có căn cứ hoặc nghi ngờ giao dịch có dấu hiệu vi phạm theo quy
                  định của Ngân hàng và Tổ chức thẻ; quy định về Phòng, chống rửa tiền và tài trợ
                  khủng bố, tài trợ phổ biến vũ khí hủy diệt hàng loạt; quy định của pháp luật.
                </li>

                <li>
                  Cam kết thực hiện đầy đủ và tuân thủ các quy định của pháp luật Việt Nam và chịu
                  trách nhiệm về tính hợp pháp của hàng hóa, dịch vụ cung ứng, bao gồm:
                  <p>
                    + Phạm vi thực hiện cung cấp hàng hóa, dịch vụ liên quan đến Hợp đồng này: trên
                    lãnh thổ Việt Nam và đúng với ngành nghề kinh doanh mà Bên B đã đăng ký với Bên
                    A.
                  </p>
                  <p>
                    + Đảm bảo hàng hóa có nguồn gốc xuất xứ rõ ràng; chính xác; phù hợp với sự mô tả
                    trên bao bì, nhãn hiệu hàng hóa. Cam kết hàng hóa, dịch vụ cung ứng đạt các yêu
                    cầu về tiêu chuẩn của loại hàng hóa, dịch vụ đó và phù hợp với nội dung đã quảng
                    bá đến Khách hàng.
                  </p>
                  <p>
                    + Chỉ lưu hành và cung cấp các loại hàng hóa, dịch vụ được phép mua bán, trao
                    đổi, thực hiện theo quy định của pháp luật hiện hành.
                  </p>
                </li>
                <li>
                  Phối hợp chặt chẽ và nghiêm túc với Bên A trong việc tuân thủ các Quy định về Bảo
                  vệ Dữ liệu cá nhân được nêu tại các văn bản quy phạm pháp luật; cụ thể:
                  <p>
                    + Xác nhận đã đọc, hiểu rõ và đồng ý kí kết với Bên A Phụ lục Bảo vệ Dữ liệu cá
                    nhân được đính kèm tại Hợp đồng này;
                  </p>
                  <p>
                    + Đồng ý và chấp thuận rằng Bên A có toàn quyền chỉnh sửa, cập nhật và điều
                    chỉnh một cách hợp lý nội dung chi tiết của Phụ lục Bảo vệ Dữ liệu cá nhân nêu
                    trên qua từng thời kỳ theo quy định của pháp luật.
                  </p>
                </li>
                <li>
                  Thường xuyên kiểm tra, giám sát các thiết bị, công cụ chấp nhận thanh toán hàng
                  hóa, dịch vụ, tránh việc sử dụng không đúng mục đích được quy định tại Hợp đồng
                  này. Bên B phải có biện pháp để ngăn ngừa và phát hiện việc sử dụng thiết bị chấp
                  nhận thanh toán không đúng thẩm quyền.
                </li>
                <li v-if="isHiddenFilePdf">
                  Cung cấp, cập nhật đầu mối liên hệ hoặc xử lý giao dịch qua email của người có
                  thẩm quyền hoặc bằng văn bản cho Bên A ít nhất 05 (năm) ngày làm việc trước ngày
                  dự kiến thay đổi.
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>CÁC HÀNH VI BỊ NGHIÊM CẤM CỦA BÊN B</h1>
          <ol>
            <li>
              Cung cấp thông tin không trung thực trong quá trình sử dụng dịch vụ của Bên A; làm, sử
              dụng, chuyển nhượng và lưu hành thẻ giả; cung cấp thông tin giả mạo để đăng ký thiết
              bị, mở tài khoản, sử dụng dịch vụ của Bên A.
            </li>
            <li v-if="!isHiddenFilePdf">
              Bên B không được cấu kết với các tổ chức, cá nhân thực hiện các hành vi gian lận, thực
              hiện giao dịch chấp nhận thanh toán khống.
            </li>
            <li>
              Mua, bán, cung cấp hay trao đổi thông tin giao dịch dưới bất kỳ hình thức nào khi chưa
              có sự chấp thuận bằng văn bản của Bên A hoặc cơ quan nhà nước có thẩm quyền.
            </li>
            <li>
              Phát hành, cung ứng và sử dụng các phương tiện thanh toán không hợp pháp, bao gồm
              nhưng không giới hạn:
              <ul>
                <li>
                  Bên B chuyển thiết bị chấp nhận thẻ, QR Code cho Bên khác sử dụng; hoặc chấp nhận
                  thanh toán thẻ mà không có hợp đồng thanh toán thẻ; hoặc di chuyển thiết bị chấp
                  nhận thanh toán đến địa điểm khác ngoài điểm chấp nhận thanh toán đã được đăng ký
                  với Bên A;
                </li>
                <li>
                  Thực hiện, tổ chức thực hiện hoặc tạo điều kiện để người khác thực hiện các hành
                  vi gian lận, giả mạo; thực hiện giao dịch chấp nhận thanh toán khống (không phát
                  sinh việc mua bán hàng hóa, cung ứng dịch vụ);
                </li>
                <li>
                  Lấy cắp, thông đồng để lấy cắp thông tin thẻ; tiết lộ và cung cấp thông tin thẻ,
                  Chủ thẻ và giao dịch thẻ không đúng quy định của pháp luật;
                </li>
                <li>Tự ý sửa chữa hoặc cài đặt thêm vào thiết bị chấp nhận thanh toán;</li>
                <li>
                  Sử dụng, lợi dụng thiết bị, công cụ, dịch vụ thanh toán làm phương tiện để thực
                  hiện hoặc tạo điều kiện thực hiện các giao dịch trái pháp luật bao gồm: đánh bạc,
                  cá độ, lừa đảo, gian lận, giao dịch kinh doanh ngoại hối, tiền ảo, rửa tiền, tài
                  trợ khủng bố và các hành vi vi phạm pháp luật khác;
                </li>
                <li>
                  Làm giả, sửa chữa, tẩy xóa, thay thế phương tiện thanh toán, chứng từ thanh toán;
                  lưu giữ, lưu hành, chuyển nhượng, sử dụng phương tiện thanh toán giả;
                </li>
                <li>
                  Lợi dụng lỗi hệ thống mạng máy tính, dữ liệu điện tử sử dụng trong thanh toán để
                  trục lợi và gây thiệt hại cho Bên A và các đơn vị/cá nhân liên quan.
                </li>
              </ul>
            </li>
            <li>
              Bên B ngừng hoạt động hoặc thay đổi thông tin đăng ký kinh doanh nhưng không thông báo
              tới Bên A theo quy định tại Hợp đồng.
            </li>
            <li>Các hành vi bị nghiêm cấm khác theo quy định của Pháp luật Việt Nam.</li>
          </ol>
        </li>
        <li>
          <h1>SỬA ĐỔI VÀ CHẤM DỨT HỢP ĐỒNG</h1>
          <ol>
            <li>
              Việc sửa đổi, bổ sung, chấm dứt Hợp đồng phải được lập thành văn bản có chữ ký xác
              nhận của người có thẩm quyền của Hai bên.
            </li>
            <li>
              Hợp đồng chấm dứt khi xảy ra một trong các sự kiện sau:
              <ul>
                <li>Hai Bên thỏa thuận chấm dứt Hợp đồng;</li>
                <li>
                  Một Bên vi phạm nghĩa vụ của mình theo quy định của Hợp đồng và không sửa chữa,
                  khắc phục được vi phạm trong thời hạn do Bên kia yêu cầu;
                </li>
                <li>
                  Trường hợp Bên B có dấu hiệu gian lận hoặc vi phạm các hành vi bị nghiêm cấm tại
                  Điều 8 của Hợp đồng này hoặc có thông báo của Ngân hàng/Tổ chức thẻ/Cơ quan nhà
                  nước có thẩm quyền yêu cầu ngừng cung cấp dịch vụ cho Bên B, Bên A có thể chấm dứt
                  Hợp đồng ngay lập tức bằng cách thông báo cho Bên B qua điện thoại, email, công
                  văn và sẽ có hiệu lực ngay lập tức mà không phụ thuộc vào bất kỳ quy định về thời
                  hạn nào tại Hợp đồng và Bên A cũng không phải bồi thường thiệt hại cho Bên B.
                </li>
                <li>
                  Sau 30 (ba mươi) ngày kể từ ngày một/các bên gửi văn bản cho bên còn lại thông báo
                  yêu cầu chấm dứt Hợp đồng;
                </li>
                <li>Một trong các Bên bị giải thể, phá sản;</li>
                <li>Các trường hợp khác theo quy định của Pháp luật Việt Nam.</li>
              </ul>
            </li>
            <li>
              Khi Hợp đồng chấm dứt, các Bên phối hợp giải quyết toàn bộ các nội dung, bao gồm nhưng
              không giới hạn các tra soát, khiếu nại, các khoản nợ và các nghĩa vụ tài chính khác
              liên quan đến việc thực hiện Hợp đồng này.
            </li>
            <li>
              Việc chấm dứt Hợp đồng theo quy định tại Điều này sẽ không làm ảnh hưởng hoặc tác động
              đến quyền lợi, nghĩa vụ và trách nhiệm của Các Bên phát sinh trước thời điểm chấm dứt,
              bao gồm nhưng không giới hạn bởi những nội dung sau:
              <ol>
                <li>
                  Thanh toán phần Phí Dịch vụ hoặc nghĩa vụ tài chính khác cho Bên còn lại cũng như
                  cho Khách hàng;
                </li>
                <li>
                  Hợp tác thanh toán những giao dịch bồi hoàn (chargeback) mà đang được xử lý hoặc
                  chưa được xử lý trước khi tiến hành chấm dứt hợp đồng;
                </li>
                <li>
                  Giải quyết các vấn đề còn tồn tại liên quan đến giao dịch thực hiện tại Bên B
                  trong thời hạn 540 (năm trăm bốn mươi) ngày kể từ ngày Hợp đồng chấm dứt hiệu lực
                  theo quy định tại Hợp đồng này.
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          <h1>CHUYỂN NHƯỢNG HỢP ĐỒNG</h1>
          <ol>
            <li>
              Không bên nào trong Hợp đồng này được chuyển nhượng một phần hoặc toàn bộ nghĩa vụ của
              hợp đồng cho bên thứ ba khi chưa có sự đồng ý bằng văn bản của bên còn lại.
            </li>
            <li>
              Trong trường hợp một bên trong hợp đồng tiến hành chia, tách, sáp nhập, hợp nhất thì
              toàn bộ quyền và nghĩa vụ của Hợp đồng này sẽ được chuyển giao cho pháp nhân/tổ chức
              có quan hệ chia, tách, sáp nhập, hợp nhất với pháp nhân bị chia, tách, sáp nhập và hợp
              nhất.
            </li>
          </ol>
        </li>
        <li>
          <h1>CÁC TRƯỜNG HỢP BẤT KHẢ KHÁNG</h1>
          <ol>
            <li>
              <span class="txt-bold">Sự kiện bất khả kháng:</span>
              <ul>
                <li>
                  <p>
                    Là sự kiện vượt ra ngoài khả năng kiểm soát của một Bên (“Bên bị ảnh hưởng”) và
                    không liên quan tới lỗi hoặc sự bất cẩn của Bên đó cũng như không thể thấy
                    trước, không thể tránh được và không thể khắc phục được mặc dù đã áp dụng mọi
                    biện pháp cần thiết và khả năng cho phép và làm cho Bên bị ảnh hưởng không thể
                    thực hiện được bất kỳ nghĩa vụ hay trách nhiệm nào quy định tại Hợp đồng này.
                  </p>
                </li>
                <li>
                  <p>
                    Sự kiện bất khả kháng ("<b>Sự kiện bất khả kháng</b>") bao gồm, nhưng không giới
                    hạn một trong các sự kiện sau:
                  </p>
                  <p>
                    - Các hiện tượng tự nhiên bao gồm: thiên tai, dịch bệnh, hoả hoạn, lũ lụt, sóng
                    thần, xoáy lốc, hạn hán, động đất cao hơn cấp thiết kế, sấm sét cao hơn mức
                    thiết kế; nhiễm hạt nhân hoặc phóng xạ.
                  </p>
                  <p>
                    - Chiến tranh, hành động xâm lược, khủng bố, bạo loạn, nội chiến, phá hoại hoặc
                    các hành động thù địch khác;
                  </p>
                  <p>
                    - Bãi công và các hoạt động ngừng trệ không phải do lỗi của một trong hai Bên
                    gây ra. Hỏng hóc kỹ thuật nằm ngoài tầm kiểm soát của mỗi Bên.
                  </p>
                  <p>- Do thay đổi chính sách pháp luật của Nhà nước Việt Nam.</p>
                </li>
              </ul>
            </li>
            <li>
              <span class="txt-bold">Thông báo:</span>
              <ul>
                <li>
                  Bên bị ảnh hưởng của Sự kiện bất khả kháng phải thông báo cho Bên kia về sự kiện,
                  tình huống gây ra Sự kiện bất khả kháng trong thời gian sớm nhất có thể nhưng
                  không được muộn hơn một (01) ngày kể từ sau khi thông tin liên lạc đã phục hồi.
                  Nhưng cũng không quá bảy (07) ngày kể từ khi xảy ra Sự kiện bất khả kháng phải
                  thông báo bằng văn bản cho Bên kia và trong vòng ba mươi (30) ngày phải gửi văn
                  bản cho Bên kia mô tả về nguyên nhân, ảnh hưởng của Sự kiện bất khả kháng đối với
                  việc thực hiện nghĩa vụ hợp đồng và gửi kèm các chứng nhận về việc xảy ra sự cố có
                  xác nhận của chính quyền địa phương.
                </li>
                <li>
                  Bất cứ các thông báo nào cũng sẽ bao gồm chi tiết về sự kiện, tình huống tạo thành
                  Sự kiện bất khả kháng, tác động của nó đối với việc thực hiện nghĩa vụ Hợp đồng
                  của Bên bị ảnh hưởng và kiến nghị các biện pháp khắc phục. Bên bị ảnh hưởng phải
                  cung cấp các báo cáo thường xuyên cho Bên kia về việc triển khai các biện pháp
                  khắc phục nhằm ngăn chặn hoặc giảm nhẹ những tác động của Sự kiện bất khả kháng và
                  các thông tin mà Bên kia yêu cầu một cách hợp lý.
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>CÁC ĐIỀU KHOẢN KHÁC</h1>
          <ol>
            <li>
              Hợp đồng này có hiệu lực trong vòng 01 (một) năm kể từ ngày ký. Trong vòng 30 (ba
              mươi) ngày trước khi hợp đồng hết hạn, nếu các bên không có thoả thuận nào khác, hợp
              đồng sẽ tự động được gia hạn liên tục 01 (một) năm một lần.
            </li>
            <li>
              Nếu một bên có bất kỳ sự thay đổi nào trong quá trình thực hiện hợp đồng, phải có
              nghĩa vụ thông báo bằng văn bản, qua email hoặc các hình thức khác (được bên kia chấp
              nhận) với bên còn lại trước ít nhất 07 (bảy) ngày kể từ ngày có sự thay đổi. Trong
              vòng 07 (bảy) ngày làm việc kể từ ngày nhận thông tin thay đổi, nếu bên nhận thông tin
              không có bất cứ phản hồi nào thì thông tin thay đổi sẽ được tự động áp dụng.<br />
              <br />Đối với các thông tin thay đổi liên quan đến đăng ký kinh doanh (do cơ quan nhà
              nước có thẩm quyền của Việt Nam cấp/xác nhận), Bên có sự thay đổi phải thông báo cho
              Bên còn lại trong vòng 07 (bảy) ngày làm việc kể từ ngày nhận được văn bản của cơ quan
              nhà nước có thẩm quyền cấp.
            </li>
            <li>
              Các bên cam kết nghiêm chỉnh thực hiện Hợp đồng này. Nếu có tranh chấp phát sinh,
              trước hết các bên sẽ cùng giải quyết bằng thương lượng. Nếu không giải quyết được, một
              trong các bên được quyền đưa tranh chấp ra Toà án có thẩm quyền để giải quyết theo thủ
              tục tố tụng được quy định bởi pháp luật Việt Nam.
            </li>
            <li>
              Hợp đồng này được lập thành 02 (hai) bản có giá trị pháp lý như nhau; mỗi Bên giữ 01
              (một) bản để thực hiện.
            </li>
          </ol>
        </li>
      </ol>
      <Footer
        :dataContract="dataContract"
        :dataAppendix="isHiddenFilePdf ? dataAppendix : null"
        :isAppendix="isHiddenFilePdf"
      ></Footer>
    </div>
  </div>
  <div v-else-if="!isHiddenFilePdf" class="pdf-list-container">
    <div
      v-if="
        dataContract &&
        dataContract.nganluongContractS3Url &&
        dataContract.nganluongContractS3Url.length
      "
    >
      <!-- <p class="pdf-list-title">Danh sách hợp đồng Ngân Lượng</p> -->
      <ul class="pdf-list">
        <li
          v-for="(url, index) in dataContract.nganluongContractS3Url"
          :key="index"
          class="pdf-list-item"
        >
          <div class="pdf-item-header" v-if="dataContract.nganluongContractS3Url.length > 1">
            <span class="pdf-index">{{ index + 1 }}.</span>
            <span class="pdf-name">Hợp đồng {{ index + 1 }}</span>
            <a :href="url" target="_blank" class="pdf-btn pdf-btn-open">Tải xuống</a>
            <button class="pdf-btn pdf-btn-view" @click="togglePdf(url)">
              {{ selectedPdfUrl === url ? '✕ Đóng' : '👁 Xem' }}
            </button>
          </div>
          <div
            v-if="selectedPdfUrl === url || dataContract.nganluongContractS3Url.length === 1"
            class="pdf-preview-wrapper"
            :class="{ 'single-pdf-wrapper': dataContract.nganluongContractS3Url.length === 1 }"
          >
            <!-- Loading overlay -->
            <div v-if="pdfLoadingUrls.includes(url)" class="pdf-loading">
              <div class="pdf-spinner"></div>
              <span>Đang tải PDF...</span>
            </div>
            <!-- Error fallback -->
            <div v-else-if="pdfErrorUrls.includes(url)" class="pdf-error">
              <span>⚠️ Không thể xem trực tiếp.</span>
              <a :href="url" target="_blank" class="pdf-btn pdf-btn-open">Mở tab mới</a>
            </div>
            <!-- Iframe (hidden while loading) -->
            <iframe
              v-show="!pdfLoadingUrls.includes(url) && !pdfErrorUrls.includes(url)"
              :src="
                'https://docs.google.com/viewer?url=' + encodeURIComponent(url) + '&embedded=true'
              "
              class="pdf-iframe"
              frameborder="0"
              @load="onIframeLoad(url)"
            ></iframe>
          </div>
        </li>
      </ul>
    </div>
    <div v-else class="pdf-empty">Không có file hợp đồng nào.</div>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import Header from '../block/headerNL.vue'
  import Footer from '../block/footerNL.vue'

  export default {
    props: ['dataContract', 'tableContactInfos', 'dataAppendix', 'isHiddenFilePdf'],
    components: {
      Header,
      Footer,
    },
    data() {
      return {
        dataConfigMcc: Config.businessFields,
        systemConfig: {},
        selectedPdfUrl: null,
        pdfLoadingUrls: [],
        pdfErrorUrls: [],
        pdfLoadedUrls: [], // URL đã load thành công — tái sử dụng mà không cần load lại
        pdfOpenTokens: {}, // vô hiệu timeout cũ khi mở lại
      }
    },
    computed: {
      customerInfo() {
        return this.dataContract?.customerInfoRes ?? this.dataContract?.customerInfoCommon ?? {}
      },
      mergedData() {
        return this.tableContactInfos.map(itemA => {
          const tableB = this.customerInfo.supportContactInfos
          const matchedTable = tableB.find(itemB => itemB.code === itemA.code)
          if (matchedTable) {
            return {
              ...itemA,
              ...matchedTable,
            }
          } else {
            return itemA
          }
        })
      },
    },
    created() {
      const urls = this.dataContract?.nganluongContractS3Url
      if (urls && urls.length === 1) {
        this.openPdf(urls[0])
      }
    },
    methods: {
      togglePdf(url) {
        if (this.selectedPdfUrl === url) {
          this.selectedPdfUrl = null
        } else {
          this.openPdf(url)
        }
      },
      openPdf(url) {
        this.selectedPdfUrl = url
        // Nếu URL đã load thành công trước đó → hiện ngay, không cần loading
        if (this.pdfLoadedUrls.includes(url)) {
          this.pdfErrorUrls = this.pdfErrorUrls.filter(u => u !== url)
          return
        }
        // reset trạng thái
        this.pdfErrorUrls = this.pdfErrorUrls.filter(u => u !== url)
        this.pdfLoadingUrls = [...this.pdfLoadingUrls.filter(u => u !== url), url]
        // token riêng — vô hiệu timeout cũ nếu URL được mở lại
        const token = Date.now()
        this.$set(this.pdfOpenTokens, url, token)
        setTimeout(() => {
          if (this.pdfOpenTokens[url] === token && this.pdfLoadingUrls.includes(url)) {
            this.pdfLoadingUrls = this.pdfLoadingUrls.filter(u => u !== url)
            this.pdfErrorUrls = [...this.pdfErrorUrls, url]
          }
        }, 12000)
      },
      onIframeLoad(url) {
        this.pdfLoadingUrls = this.pdfLoadingUrls.filter(u => u !== url)
        // Đánh dấu đã load thành công để lần sau hiện ngay
        if (!this.pdfLoadedUrls.includes(url)) {
          this.pdfLoadedUrls = [...this.pdfLoadedUrls, url]
        }
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>

<style scoped>
  .pdf-list-container {
    padding: 0;
  }
  .pdf-list-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .pdf-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .pdf-list-item {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    margin-bottom: 10px;
    overflow: hidden;
    background: #fafafa;
  }
  .pdf-item-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
  }
  .pdf-index {
    font-weight: 600;
    color: #555;
    min-width: 24px;
  }
  .pdf-name {
    flex: 1;
    font-size: 14px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .pdf-btn {
    padding: 5px 12px;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    text-decoration: none;
    white-space: nowrap;
    border: none;
  }
  .pdf-btn-open {
    background: #e8f0fe;
    color: #1a73e8;
  }
  .pdf-btn-open:hover {
    background: #d2e3fc;
  }
  .pdf-btn-view {
    background: #e6f4ea;
    color: #188038;
  }
  .pdf-btn-view:hover {
    background: #ceead6;
  }
  .pdf-preview-wrapper {
    border-top: 1px solid #e0e0e0;
    position: relative;
  }
  .pdf-preview-wrapper.single-pdf-wrapper {
    border-top: none;
  }
  .pdf-iframe {
    width: 100%;
    height: 95vh;
    display: block;
  }
  .pdf-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    gap: 12px;
    color: #555;
    font-size: 14px;
  }
  .pdf-spinner {
    width: 36px;
    height: 36px;
    border: 4px solid #e0e0e0;
    border-top-color: #1a73e8;
    border-radius: 50%;
    animation: pdf-spin 0.8s linear infinite;
  }
  @keyframes pdf-spin {
    to {
      transform: rotate(360deg);
    }
  }
  .pdf-error {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    background: #fff8e1;
    color: #856404;
    font-size: 14px;
  }
  .pdf-empty {
    color: #888;
    font-size: 14px;
    padding: 16px;
  }
</style>
